import React from 'react';
import { GlobalDocumentIds } from '../../../../types/GlobalDocumentIds';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';
import { useGlobalMenu } from '../../../../contexts/GlobalMenuStore';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { SkipLink } from '../../SkipLink';

export function PageLeadSkipLinks() {
  const { toggleNav } = useGlobalMenu();
  const { t } = useSonTranslation('PageLead');

  const { availableSections } = useAppContext();
  const hasSkipLinks = availableSections.pageManagement || availableSections.navigation;

  if (!hasSkipLinks) {
    return null;
  }

  return (
    <div className="page-lead__skiplink">
      {availableSections.navigation && (
        <SkipLink
          id={GlobalDocumentIds.mainNavigation}
          onClick={() => toggleNav()}
          focusTarget
          stopPropagation
        >
          {t('skipToNavigation')}
        </SkipLink>
      )}
      {availableSections.pageManagement && (
        <SkipLink id={GlobalDocumentIds.pageManagement}>{t('skipToPageManagement')}</SkipLink>
      )}
    </div>
  );
}
